import React, { useState } from 'react'

function CommentForm(props){

    const [commentBody, setCommentBody] = useState('')

    const handleCommentChange = (e) => {
        setCommentBody(e.target.value)
    }

    const handleOnClick = (e) => {
        setCommentBody('')
        props.addComment(commentBody)
    }

    return(
        <div>
            <h1>
                <div>
                    <div className="col-12 mt-5">
                        <textarea onChange={handleCommentChange} value={commentBody} className="form-control" name="" id="" cols="10" rows="5"></textarea>
                        <button onClick={handleOnClick} className="mt-3 btn btn-dark" type="button">Submit</button>
                    </div>
                </div>
            </h1>
        </div>
    )
}

export default CommentForm